<template>
  <div class="cb-section cb-bar" :class="[{'cb-bar--left' : navIcon == 'left', 'cb-bar--right' : navIcon == 'right'}]" @click="navigate()" v-cb-link="isLink && 'shadow'"
    :role="'navigation'" data-cb-id="estimate-fixed">
    <div class="cb-bar__wrap cb-bar__wrap--nohover">
      <div class="cb-bar__content">
        <div class="cb-bar__items">
          <div class="cb-bar__item" :style="isLink && themeColor">
            <div class="cb-bar__main"><span v-cb-html="title"></span></div>
            <div class="cb-bar__aside">{{ current_amount_due | cbCurrency(currency_code) }}</div>
          </div>
          <div class="cb-bar__item" v-if="firstNextEstimate">
            <div class="cb-bar__main"><span>{{t('cart.next_charge.label', {date: date(firstNextEstimate.date)})}}</span></div>
            <div class="cb-bar__aside">{{ nextInvAmountDue | cbCurrency(currency_code)}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import CartHelper from "@/utils/cart-helper"
export default {
  props: ['editOrder', 'navIcon', 'fromCart'],
  computed: {
    ...mapGetters([
      'currency_code',
      'order_estimate_holder',
      'current_amount_due',
      'cart_items',
      'is_checkout_one_time'
    ]),
    firstNextEstimate() {
      return this.order_estimate_holder.nextEstimates && this.order_estimate_holder.nextEstimates[0];
    },
    title() {
      if(!this.is_checkout_one_time) {
        return this.t('cart.pay_now.label');
      }
      if(this.cart_items && this.cart_items.length > 1) {
        return this.sanitizeTag(this.t('cart.header') + ' <span class="cb-tc--muted">' + this.cart_items.length + ' ' + this.st('cart.item_text') + '</span>');
      } else if(this.cart_items && this.cart_items.length == 1) {
        let item = this.cart_items[0];
        let details = item.details;
        return (
          item.description ||
          (details && details.invoice_name) ||
          (details && details.name) ||
          (details && details.description) ||
          ""
        );
      }
    },
    isLink() {
      return !this.is_checkout_one_time;
    },
    nextInvAmountDue() {
      return (this.firstNextEstimate && this.firstNextEstimate.amount_due) || 0;
    }
  },
  methods: {
    navigate() {
      var section = this.fromCart ? "estimate_display_screen" : 
            (this.editOrder ? "estimate_display_screen" : "cart_new");
      var mode = this.editOrder ? "edit" : "";
      this.$router.customPush({
        name: section,
        query: {
          mode: mode
        }
      });
    },
    sanitizeTag(content, allowedTags) {
      return {
        text: content, 
        tags:['span'], 
        attrs:{span : ["class"]}
        }
    }
  }

}
</script>
